(() => {
  const SELECTOR = '[data-why-choose-us]';

  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    if (!window.Splide) return;

    const el = root.querySelector('.why-choose-us__splide');
    if (!el) return;

    const count = el.querySelectorAll('.why-choose-us__slide').length;
    if (!count) return;

    root.dataset.ready = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root._splide = new window.Splide(el, {
      type: 'fade',
      rewind: true,
      perPage: 1,
      speed: 600,
      drag: count > 1,
      arrows: false,
      pagination: count > 1,
      autoplay: count > 1 && !reduceMotion,
      interval: 5000,
      pauseOnHover: true,
      pauseOnFocus: true
    }).mount();
  };

  const boot = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll(SELECTOR).forEach((root) => {
      if (root._splide) {
        root._splide.destroy(true);
        delete root._splide;
      }
      delete root.dataset.ready;
    });
  });
})();
